export default "__VITE_ASSET__CiMD84yk__"